import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  hideSmall: {
    [theme.breakpoints.down('xl')]: {
      display: 'none',
    },
  },
}));

export default useStyles;
